module.exports = __webpack_public_path__ + "img/post-2.7dde0180.png";